<div class="pending-special-wrapper" [ngClass]="{ 'unsubmitted-coupon': !special() }">
    <cwo-icon class="error-icon" [name]="iconNameType.error" />
    <span class="name">{{special()?.name ?? 'Pending Coupon'}}</span>
    <button class="remove-button" type="button" (click)="removeSpecial()">
        <cwo-icon class="close-icon" [name]="iconNameType.close" [size]="'0.75rem'" />
    </button>
</div>